import React, { ComponentType } from 'react'
import { Drawer, DrawerProps, styled } from '@mui/material'
import { useRoutes } from '@src/AppRoutes'
import { NavLink, NavLinkProps } from 'react-router'
import SidebarLogo from '@components/Layout/SidebarLogo'
import SidebarNav from '@components/Layout/SidebarNav'
import { setSidebarOpen, useSidebarOpen, useSidebarWidth } from '@store/app'
import { DEFAULT_SIDEBAR_WIDTH } from '@src/config'
import { useAppDispatch, useIsTablet } from '@src/hooks'

export type SidebarProps = DrawerProps & {

}

const Sidebar = styled(({ sx, ...props }: SidebarProps) => {
  const sideBarWidth = useSidebarWidth()
  const sidebarOpen = useSidebarOpen()
  const routes = useRoutes()
  const dispatch = useAppDispatch()
  const isTablet = useIsTablet()

  const sideBarCloseHandler = () => {
    dispatch(setSidebarOpen(false))
  }

  sx = Object.assign({}, sx || {}, {
    width: sidebarOpen ? DEFAULT_SIDEBAR_WIDTH : sideBarWidth,
    '& .MuiDrawer-paper': {
      width: sidebarOpen ? DEFAULT_SIDEBAR_WIDTH : sideBarWidth,
    }
  })

  return (
    <Drawer
      {...props}
      sx={sx}
      variant={isTablet ? 'temporary' : 'permanent'}
      open={sidebarOpen}
      anchor="left"
      onClose={sideBarCloseHandler}
    >
      <SidebarLogo />

      <SidebarNav sx={{ mt: isTablet ? 4 : 9.5 }}>
        {routes.filter(r => !r.hidden).map((route) => {

          const NavLinkElement: ComponentType<NavLinkProps> = route.navLink || NavLink

          return (
            <NavLinkElement
              className={({ isActive }) => isActive ? 'active': ''}
              onClick={sideBarCloseHandler}
              key={route.path}
              to={route.path}
            >
              {route.title}
            </NavLinkElement>
          )
        })}
      </SidebarNav>

    </Drawer>
  )
})(({ theme }) => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    boxShadow: '0px 5px 25px 5px rgba(0, 0, 0, 0.3)',
    backgroundColor: theme.palette.secondary.main,
    boxSizing: 'border-box',
    border: 'none',
    justifyContent: 'start',
  }
}))

export default Sidebar